<template>
  <div class="dialog-root">
    <div class="container">
      <el-form label-width="100px">
        <el-row>
          <el-col span="12">
            <el-form-item label="任务名称：">
              <el-input v-model="detailData.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="任务类型：">
              <el-input v-model="detailData.typeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="任务日期：">
              <el-input
                :value="detailData.startDate + '-' + detailData.endDate"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="时间段：">
              <el-input v-model="detailData.timePeriod" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="话术：">
              <el-input v-model="detailData.dialogue" type="textarea" autosize disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="呼叫对象：">
              <avue-crud
                ref="crud"
                :option="tableOption"
                :data="detailData.callcenterCallTaskDetailList"
                :page.sync="tablePage"
              >
              </avue-crud>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getDetailApi } from '@/api/call-system/call-manage/outbound-task';

export default {
  name: 'ViewDialog',
  props: ['projectId', 'rowData'],
  data() {
    return {
      detailData: {
        userList: [],
      }, // 详情数据
      // 表格分页信息
      tablePage: {
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        searchShowBtn: false,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '联系电话',
            prop: 'phone',
          },
          {
            label: '呼叫状态',
            prop: 'callStatusName',
          },
        ],
      },
    };
  },
  created() {
    getDetailApi({
      id: this.rowData.id,
    }).then(({ data }) => {
      this.detailData = data;
    });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
}

/* 表格上方按钮栏未配置内容时依然占着位置，会产生一个很大的空白区域，需要去掉 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
